export function getUserAccessLevel(user_type = 'viewer', access_type = 'viewer'){

    var user_types = ['viewer', 'editor', 'technician', 'admin'];
    var user_level = user_types.indexOf(user_type);
    var access_level = user_types.indexOf(access_type);

    if(user_level >= access_level){
        return true;
    }

    return false;
}